import React, { useState, useEffect } from "react";
import styles from "./search_form.module.css";


function SearchForm(
  // { handleSubmit }
) {

  const [inputValue, setInputValue] = useState('');
  const [isEmptyInput, setIsEmptyInput] = useState(false);
  const [inputFocus, setInputFocus] = useState(false);

  const handleChangeInput = (e) => {
    setInputValue(e.target.value);
  }

  const handleFocusForm = (e) => {
    setInputFocus(true);
  }
  const handleBlurForm = (e) => {
    setInputFocus(false);
  }


  useEffect(() => {
    setInputValue(localStorage.getItem('keyWord'));
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();

    // handleSubmit({
    //   keyWord: inputValue
    // });

    // inputValue ? setIsEmptyInput(false) : setIsEmptyInput(true);
  }


  return (
    <form
      className={
        `${styles.form}
        ${inputFocus && styles.formFocus}
        ${isEmptyInput && styles.formError}`
      }
      onSubmit={onSubmit}
      noValidate
    >
      <input
        id="search-input"
        name="search"
        className={`${styles.input}`}
        type="text"
        placeholder="Поиск"
        onChange={handleChangeInput}
        onFocus={handleFocusForm}
        onBlur={handleBlurForm}
        value={inputValue || ''}
      />
      <button type="submit" className={`${styles.button}`} />
      <p className={`${styles.errorText} ${isEmptyInput && styles.errorText_visible}`}>
        нужно ввести ключевое слово
      </p>
    </form>
  );
}

export default SearchForm;
